import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  Grid,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import fr from "date-fns/locale/fr";

// Modal for Cash Payments
export const EditAchatCashPaymentModal = ({ open, onClose, payment, onSave }) => {
  const [formData, setFormData] = useState(payment || {});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDateChange = (date) => {
    setFormData((prev) => ({
      ...prev,
      date_paiement: date,
    }));
  };

  const handleSubmit = () => {
    onSave({
      ...formData,
      id_paiement_cash: payment?.id_paiement_cash,
      id_achat: payment?.id_achat,
      categorie_code: payment?.categorie_code,
    });
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Modifier le Paiement Cash Fournisseur</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} className="mt-4">
          <Grid item xs={12} sm={6}>
            <LocalizationProvider
              dateAdapter={AdapterDateFns}
              adapterLocale={fr}
            >
              <DatePicker
                label="Date de Paiement"
                value={
                  formData.date_paiement
                    ? new Date(formData.date_paiement)
                    : null
                }
                onChange={handleDateChange}
                renderInput={(params) => <TextField {...params} fullWidth />}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Montant à Payer"
              name="montant_a_payer"
              type="number"
              value={formData.montant_a_payer || ""}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Montant Payé"
              name="montant_paye"
              type="number"
              value={formData.montant_paye || ""}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <InputLabel>Mode de Paiement</InputLabel>
              <Select
                name="mode_paiement"
                value={formData.mode_paiement || ""}
                onChange={handleChange}
                label="Mode de Paiement"
              >
                <MenuItem value="Espèces">Espèces</MenuItem>
                <MenuItem value="Carte">Carte</MenuItem>
                <MenuItem value="Chèque">Chèque</MenuItem>
                <MenuItem value="Virement">Virement</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Référence Paiement"
              name="reference_paiement"
              value={formData.reference_paiement || ""}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Commentaire"
              name="commentaire"
              multiline
              rows={2}
              value={formData.commentaire || ""}
              onChange={handleChange}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Annuler</Button>
        <Button onClick={handleSubmit} variant="contained" color="secondary">
          Enregistrer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

// Modal for Installment Payments
export const EditAchatInstallmentModal = ({ open, onClose, payment, onSave }) => {
  const [formData, setFormData] = useState(payment || {});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDateChange = (field, date) => {
    setFormData((prev) => ({
      ...prev,
      [field]: date,
    }));
  };

  const handleSubmit = () => {
    onSave({
      ...formData,
      id_paiement_tranche: payment?.id_paiement_tranche,
      id_achat: payment?.id_achat,
      categorie_code: payment?.categorie_code,
    });
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Modifier le Paiement en Tranches Fournisseur</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} className="mt-4">
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Nombre de Tranches"
              name="nombre_tranches"
              type="number"
              value={formData.nombre_tranches || ""}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Montant Total"
              name="montant_total"
              type="number"
              value={formData.montant_total || ""}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Montant par Tranche"
              name="montant_par_tranche"
              type="number"
              value={formData.montant_par_tranche || ""}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <LocalizationProvider
              dateAdapter={AdapterDateFns}
              adapterLocale={fr}
            >
              <DatePicker
                label="Date de Début"
                value={
                  formData.date_debut
                    ? new Date(formData.date_debut)
                    : null
                }
                onChange={(date) => handleDateChange("date_debut", date)}
                renderInput={(params) => <TextField {...params} fullWidth />}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Commentaire"
              name="commentaire"
              multiline
              rows={2}
              value={formData.commentaire || ""}
              onChange={handleChange}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Annuler</Button>
        <Button onClick={handleSubmit} variant="contained" color="secondary">
          Enregistrer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default { EditAchatCashPaymentModal, EditAchatInstallmentModal };
